// matches ORGANIZATION_USER_ID in backend
export const ORGANIZATION_USER_ID = "organization";

export const notificationMethod = {
  EMAIL: "email",
  SLACK: "slack",
  MICROSOFT_TEAMS: "microsoft_teams",
};

export const categoryName = {
  ACCOUNT: "account",
  ORGANIZATION_SETTINGS: "organization_settings",
  // matches NotificationCategory in backend
  ORGANIZATION_NOTIFICATIONS: "organization",
  PERSONAL: "personal",
  AUDIT: "audit",
};

export const pageName = {
  PROFILE: "profile",
  MEMBERS: "members",
  SSO: "sso",
  STATIC_IP_ADDRESSES: "static_ip_addresses",
  HEATMAP: "heatmap",
  GENERAL: "general",
  RISK: "risk",
  ASSETS: "assets",
  SCAN_HEALTH: "scan_health",
  AUDIT_LOGS: "audit_logs",
  API_KEYS: "api_keys",
  MCP: "mcp",
};

export const categoryAccess = {
  ALL: "All",
  MANAGERS_ONLY: "Managers Only",
  ALL_BUT_MSSP: "All But MSSP",
};

export const defaultTimezone = "Asia/Jerusalem";

// NOTE - using lists for multiple display options for the same timezone
export const customerTimezone = {
  "Asia/Jerusalem": ["Jerusalem, Israel"],
  "Europe/Berlin": ["Berlin, Germany"],
  "US/Pacific": ["US Pacific", "PST"],
  "US/Eastern": ["US Eastern", "EST"],
  "Europe/London": ["London, UK"],
};

// Currently used as options for scheduled notifications only
export const additionalTimezone = {
  "Europe/Athens": ["Athens, Greece"],
  "America/Chicago": ["Chicago, US"],
  "America/Denver": ["Denver, US"],
  "Asia/Dubai": ["Dubai, UAE"],
  "Asia/Kolkata": ["Mumbai, India"],
  "America/Los_Angeles": ["Los Angeles, US"],
  "Europe/Moscow": ["Moscow, Russia"],
  "America/New_York": ["New York, US"],
  "Asia/Shanghai": ["Shanghai, China"],
  "Asia/Tokyo": ["Tokyo, Japan"],
};

export const popularTimezonesLocationMapping = {
  ...customerTimezone,
  ...additionalTimezone,
};
